export type Language = "de" | "en";

type Translations = Record<string, string>;

const translations: Record<Language, Translations> = {
  de: {
    "NAV.HOME": "Startseite",
    "NAV.ABOUT": "Leistungen",
    "NAV.SKILLS": "Technologien",
    "NAV.PROJECTS": "Referenzen",
    "NAV.BLOG": "Blog",
    "NAV.CONTACT": "Kontakt",
    "HERO.GREETING": "Digitale Lösungen für Ihr Business",
    "HERO.TITLE": "Maßgeschneiderte Software-Entwicklung",
    "HERO.DESCRIPTION":
      "Ich verwandle Ihre Visionen in leistungsstarke, skalierbare digitale Produkte. Von modernen Web-Apps bis zu komplexen Anwendungen – ich liefere Ergebnisse, die Ihr Unternehmen voranbringen.",
    "HERO.CTA.QUOTE": "Projekt besprechen",
    "HERO.CTA.WORK": "Referenzen anfragen",
    "TRUST.TITLE": "Mit mir auf dem richtigen Weg",
    "TRUST.SUBTITLE": "Ihre IT-Lösung in besten Händen",
    "TRUST.BENEFITS.TITLE": "Ihre Vorteile",
    "TRUST.BENEFITS.B1.TITLE": "Schnellere Markteinführung",
    "TRUST.BENEFITS.B1.DESC":
      "Effiziente Entwicklung spart Zeit und bringt Ihr Produkt schneller auf den Markt.",
    "TRUST.BENEFITS.B2.TITLE": "Kosteneinsparung",
    "TRUST.BENEFITS.B2.DESC":
      "Optimierte Lösungen reduzieren langfristige Betriebskosten und steigern Ihre Profitabilität.",
    "TRUST.BENEFITS.B3.TITLE": "Skalierbare Lösungen",
    "TRUST.BENEFITS.B3.DESC":
      "Ihre IT-Infrastruktur wächst mit Ihrem Geschäft – heute und in Zukunft.",
    "TRUST.PROMISE.TITLE": "Mein Versprechen",
    "TRUST.PROMISE.P1.TITLE": "Qualität garantiert",
    "TRUST.PROMISE.P1.DESC":
      "Hochwertiger Code und bewährte Best Practices für langfristige Stabilität.",
    "TRUST.PROMISE.P2.TITLE": "Transparente Kommunikation",
    "TRUST.PROMISE.P2.DESC":
      "Regelmäßige Updates und klare Kommunikation – Sie wissen immer, wo Ihr Projekt steht.",
    "TRUST.PROMISE.P3.TITLE": "Pünktliche Lieferung",
    "TRUST.PROMISE.P3.DESC":
      "Termintreue ist selbstverständlich. Ihre Deadlines sind meine Priorität.",
    "TRUST.PROCESS.TITLE": "Mein Prozess",
    "TRUST.PROCESS.S1.TITLE": "Analyse",
    "TRUST.PROCESS.S1.DESC":
      "Tiefgreifende Analyse Ihrer Anforderungen und Ziele.",
    "TRUST.PROCESS.S2.TITLE": "Planung",
    "TRUST.PROCESS.S2.DESC":
      "Strategische Planung für den optimalen Lösungsweg.",
    "TRUST.PROCESS.S3.TITLE": "Entwicklung",
    "TRUST.PROCESS.S3.DESC":
      "Agile Entwicklung mit regelmäßigem Feedback-Loop.",
    "TRUST.PROCESS.S4.TITLE": "Live-Schaltung",
    "TRUST.PROCESS.S4.DESC":
      "Sorgfältiges Deployment und laufender Support nach dem Launch.",
    "ABOUT.TITLE":
      "Ich bin Fullstack Entwickler und biete dir die beste IT-Lösung",
    "ABOUT.BIO":
      "Von der Idee bis zur Live-Schaltung – ich begleite Ihr Projekt von Anfang bis Ende. Frontend, Backend, Mobile Apps und Cloud-Infrastruktur aus einer Hand.",
    "ABOUT.H1": "Kundenfokus",
    "ABOUT.H2": "Skalierbar",
    "ABOUT.H3": "Support",
    "ABOUT.S1.TITLE": "Web & Apps",
    "ABOUT.S1.DESC":
      "Moderne Webanwendungen und mobile Apps für alle Plattformen",
    "ABOUT.S2.TITLE": "Cloud & DevOps",
    "ABOUT.S2.DESC":
      "Skalierbare Infrastruktur und automatisierte Deployment-Prozesse",
    "ABOUT.S3.TITLE": "Mobile Entwicklung",
    "ABOUT.S3.DESC": "Native iOS Apps und Cross-Platform Lösungen",
    "EXPERIENCE.TITLE": "Konkrete Geschäftsvorteile",
    "EXPERIENCE.JOB1.TITLE": "Web- & App-Entwicklung",
    "EXPERIENCE.JOB1.COMPANY": "Frontend, Backend & Mobile",
    "EXPERIENCE.JOB1.DATE": "Fullstack",
    "EXPERIENCE.JOB1.DESC":
      "Steigern Sie Ihre Online-Präsenz mit maßgeschneiderten Lösungen – von einfachen Websites bis hin zu komplexen Webanwendungen. Ihre Nutzer profitieren von modernen, performanten Anwendungen.",
    "EXPERIENCE.JOB2.TITLE": "Cloud & Programmatic SEO",
    "EXPERIENCE.JOB2.COMPANY": "Skalierbar & Sichtbar",
    "EXPERIENCE.JOB2.DATE": "Cloud Native",
    "EXPERIENCE.JOB2.DESC":
      "Maximieren Sie Ihre Sichtbarkeit und reduzieren Sie Infrastrukturkosten mit modernen Cloud-Lösungen. Programmatic SEO bringt organischen Traffic auf Ihre Seite.",
    "SKILLS.TITLE": "Technologien, die Ihren Erfolg sichern",
    "SKILLS.SUBTITLE":
      "Von Frontend bis Mobile – die richtigen Tools für Ihr Projekt",
    "SKILLS.FRONTEND.TITLE": "Moderne Web Anwendungen",
    "SKILLS.BACKEND.TITLE": "Robuste Geschäftslogik",
    "SKILLS.MOBILE.TITLE": "Native & Cross-Platform Apps",
    "SKILLS.CLOUD.TITLE": "Skalierbare Cloud Infrastruktur",
    "PROJECTS.TITLE": "Erfolgsgeschichten",
    "PROJECTS.SUBTITLE": "Lösungen, die Ergebnisse bringen",
    "PROJECTS.P1.TITLE": "E-Commerce Plattform",
    "PROJECTS.P1.DESC":
      "Steigerung des Online-Umsatzes um 40% durch moderne E-Commerce-Lösung mit Echtzeit-Inventarverwaltung und optimierter User Experience.",
    "PROJECTS.P2.TITLE": "Task Management App",
    "PROJECTS.P2.DESC":
      "Effizienzsteigerung von 60% durch kollaboratives Task-Management-Tool. Teams arbeiten produktiver dank Echtzeit-Updates und nahtloser Synchronisation.",
    "PROJECTS.P3.TITLE": "Online Präsenz für eine KfZ Prüfstelle",
    "PROJECTS.P3.DESC":
      "Professionelle Online-Präsenz mit verbesserter Sichtbarkeit: 3x mehr Leads durch optimierte Performance und moderne Designsprache.",
    "PROJECTS.VIEW_CODE": "Code ansehen",
    "PROJECTS.LIVE_DEMO": "Live Demo",
    "CONTACT.TITLE": "Starten wir Ihr Projekt",
    "CONTACT.SUBTITLE": "Bereit, Ihr Geschäft auf die nächste Stufe zu heben?",
    "CONTACT.TEXT":
      "Lassen Sie uns gemeinsam Ihre Vision in eine profitable Realität umsetzen. Ich entwickle maßgeschneiderte IT-Lösungen, die Ihr Geschäft voranbringen und messbare Ergebnisse liefern.",
    "CONTACT.FORM.NAME": "Ihr Name",
    "CONTACT.FORM.EMAIL": "Ihre E-Mail",
    "CONTACT.FORM.PHONE": "Telefonnummer (Optional)",
    "CONTACT.FORM.PROJECT_TYPE": "Art des Projekts",
    "CONTACT.FORM.PROJECT_TYPE.WEBSITE": "Website",
    "CONTACT.FORM.PROJECT_TYPE.WEBAPP": "Web Applikation",
    "CONTACT.FORM.PROJECT_TYPE.MOBILE": "Mobile App",
    "CONTACT.FORM.PROJECT_TYPE.BACKENDPROCESS": "Serverseitige Anwendung",
    "CONTACT.FORM.PROJECT_TYPE.CLOUD": "Cloud & DevOps",
    "CONTACT.FORM.PROJECT_TYPE.SEO": "SEO Optimierung",
    "CONTACT.FORM.PROJECT_TYPE.OTHER": "Sonstiges",
    "CONTACT.FORM.BUDGET": "Budget Vorstellung",
    "CONTACT.FORM.BUDGET.LOW": "Unter 2.000€",
    "CONTACT.FORM.BUDGET.MEDIUM": "2.000€ - 5.000€",
    "CONTACT.FORM.BUDGET.HIGH": "5.000€ - 10.000€",
    "CONTACT.FORM.BUDGET.PREMIUM": "Über 10.000€",
    "CONTACT.FORM.SUBJECT": "Betreff",
    "CONTACT.FORM.MESSAGE": "Ihre Nachricht",
    "CONTACT.FORM.SUBMIT": "Anfrage senden",
    "CONTACT.ADDRESS": "München, Deutschland",
    "CONTACT.SUCCESS":
      "Vielen Dank für Ihre Nachricht! Ich melde mich in Kürze bei Ihnen.",
    "CONTACT.ERROR":
      "Entschuldigung, beim Senden Ihrer Nachricht ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder schreiben Sie mir direkt an kontakt@koricode.de.",
    "CONTACT.TIMEOUT":
      "Die Anfrage dauert länger als erwartet. Ihr E-Mail-Programm wird geöffnet.",
    "CONTACT.FALLBACK":
      "Ihr E-Mail-Programm wurde geöffnet. Bitte senden Sie die Nachricht von dort aus.",
    "NEWSLETTER.SUCCESS":
      "Vielen Dank für Ihre Anmeldung! Sie haben sich erfolgreich für den Newsletter registriert.",
    "NEWSLETTER.ERROR":
      "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
    "NEWSLETTER.TITLE": "Bleib auf dem Laufenden",
    "NEWSLETTER.DESCRIPTION":
      "Abonniere meinen Newsletter und erhalte die neuesten Updates zu Projekten, Blog-Posts und Technologie-Trends direkt in dein Postfach.",
    "NEWSLETTER.FORM.EMAIL_PLACEHOLDER": "Deine E-Mail-Adresse",
    "NEWSLETTER.FORM.REQUIRED": "E-Mail-Adresse ist erforderlich",
    "NEWSLETTER.FORM.INVALID": "Bitte gib eine gültige E-Mail-Adresse ein",
    "NEWSLETTER.FORM.SUBMIT": "Abonnieren",
    "NEWSLETTER.FORM.SUBMITTING": "Wird gesendet...",
    "COOKIE.TITLE": "Cookie-Einstellungen",
    "COOKIE.TEXT":
      "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern und anonyme Nutzungsdaten zu sammeln. Sie können entscheiden, welche Cookies Sie zulassen möchten.",
    "COOKIE.ACCEPT_ALL": "Alle akzeptieren",
    "COOKIE.NECESSARY": "Nur notwendige",
    "FOOTER.RIGHTS": "Alle Rechte vorbehalten.",
    "FOOTER.LEGAL.IMPRESSUM": "Impressum",
    "FOOTER.LEGAL.PRIVACY": "Datenschutz",
    "PRIVACY.TITLE": "Datenschutzerklärung",
    "PRIVACY.STATUS": "Stand",
    "PRIVACY.MONTH.1": "Januar",
    "PRIVACY.MONTH.2": "Februar",
    "PRIVACY.MONTH.3": "März",
    "PRIVACY.MONTH.4": "April",
    "PRIVACY.MONTH.5": "Mai",
    "PRIVACY.MONTH.6": "Juni",
    "PRIVACY.MONTH.7": "Juli",
    "PRIVACY.MONTH.8": "August",
    "PRIVACY.MONTH.9": "September",
    "PRIVACY.MONTH.10": "Oktober",
    "PRIVACY.MONTH.11": "November",
    "PRIVACY.MONTH.12": "Dezember",
    "PRIVACY.SECTION1.TITLE": "Datenschutz auf einen Blick",
    "PRIVACY.SECTION1.SUBTITLE": "Allgemeine Hinweise",
    "PRIVACY.SECTION1.TEXT":
      "Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.",
    "PRIVACY.SECTION2.TITLE": "Datenerfassung auf dieser Website",
    "PRIVACY.SECTION2.Q1":
      "Wer ist verantwortlich für die Datenerfassung auf dieser Website?",
    "PRIVACY.SECTION2.A1":
      "Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.",
    "PRIVACY.SECTION2.Q2": "Wie erfassen wir Ihre Daten?",
    "PRIVACY.SECTION2.A2.P1":
      "Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.",
    "PRIVACY.SECTION2.A2.P2":
      "Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst und dienen ausschließlich statistischen Zwecken zur Verbesserung des Angebots.",
    "PRIVACY.SECTION3.TITLE": "Cookies",
    "PRIVACY.SECTION3.P1":
      "Unsere Website verwendet Cookies. Das sind kleine Textdateien, die Ihr Webbrowser auf Ihrem Endgerät speichert. Cookies helfen dabei, das Angebot nutzerfreundlicher zu machen.",
    "PRIVACY.SECTION3.P2": "Wir verwenden folgende Cookie-Kategorien:",
    "PRIVACY.SECTION3.NECESSARY": "Notwendige Cookies:",
    "PRIVACY.SECTION3.NECESSARY.DESC":
      "Ermöglichen Grundfunktionen der Website",
    "PRIVACY.SECTION3.ANALYTICAL": "Analytische Cookies:",
    "PRIVACY.SECTION3.ANALYTICAL.DESC":
      "Helfen uns, die Nutzung der Website zu verstehen (nur mit Ihrer Einwilligung)",
    "PRIVACY.SECTION3.P3":
      "Sie können Ihre Cookie-Einstellungen jederzeit über den Cookie-Banner am unteren Bildschirmrand ändern.",
    "PRIVACY.SECTION4.TITLE": "Kontaktformular",
    "PRIVACY.SECTION4.TEXT":
      "Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.",
    "PRIVACY.SECTION5.TITLE": "Ihre Rechte",
    "PRIVACY.SECTION5.INTRO": "Sie haben jederzeit das Recht:",
    "PRIVACY.SECTION5.RIGHT1":
      "Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten",
    "PRIVACY.SECTION5.RIGHT2": "Berichtigung unrichtiger Daten zu verlangen",
    "PRIVACY.SECTION5.RIGHT3": "Löschung Ihrer Daten zu verlangen",
    "PRIVACY.SECTION5.RIGHT4":
      "Einschränkung der Datenverarbeitung zu verlangen",
    "PRIVACY.SECTION5.RIGHT5": "Widerspruch gegen die Verarbeitung einzulegen",
    "PRIVACY.SECTION5.RIGHT6": "Datenübertragbarkeit zu verlangen",
    "PRIVACY.SECTION5.CONTACT":
      "Wenden Sie sich hierzu bitte an: kontakt@koricode.de",
    "PRIVACY.SECTION6.TITLE": "Newsletter",
    "PRIVACY.SECTION6.TEXT1":
      "Wenn Sie den auf der Website angebotenen Newsletter abonnieren möchten, benötigen wir von Ihnen eine E-Mail-Adresse sowie Informationen, welche uns die Überprüfung gestatten, dass Sie der Inhaber der angegebenen E-Mail-Adresse sind und mit dem Empfang des Newsletters einverstanden sind.",
    "PRIVACY.SECTION6.TEXT2":
      "Rechtsgrundlage für die Verarbeitung der Daten nach Anmeldung zum Newsletter ist bei Vorliegen einer Einwilligung Art. 6 Abs. 1 lit. a DSGVO. Sie können Ihre Einwilligung zum Erhalt des Newsletters jederzeit widerrufen, etwa über den Abmeldelink im Newsletter. Die Rechtmäßigkeit der bereits erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.",
    "PRIVACY.SECTION7.TITLE": "Server-Log-Dateien",
    "PRIVACY.SECTION7.TEXT":
      "Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Files erfasst werden.",
    "PRIVACY.SECTION8.TITLE": "Besucher-Tracking",
    "PRIVACY.SECTION8.TEXT1":
      "Diese Website nutzt ein Besucher-Tracking-System, um statistische Informationen über die Nutzung der Website zu sammeln. Hierbei werden folgende Daten erfasst und gespeichert:",
    "PRIVACY.SECTION8.LIST1": "IP-Adresse",
    "PRIVACY.SECTION8.LIST2": "User-Agent (Browsertyp und -version)",
    "PRIVACY.SECTION8.LIST3": "Spracheinstellungen",
    "PRIVACY.SECTION8.LIST4": "Referrer-URL (von welcher Seite Sie kommen)",
    "PRIVACY.SECTION8.LIST5": "Bildschirmauflösung und Farbtiefe",
    "PRIVACY.SECTION8.LIST6": "Zeitzone",
    "PRIVACY.SECTION8.LIST7": "Hardware-Informationen (soweit verfügbar)",
    "PRIVACY.SECTION8.LIST8": "Besuchte Seiten",
    "PRIVACY.SECTION8.TEXT2":
      "Die Erfassung dieser Daten erfolgt nur mit Ihrer ausdrücklichen Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) über unseren Cookie-Banner. Sie können Ihre Einwilligung jederzeit widerrufen, indem Sie die Cookie-Einstellungen anpassen.",
    "PRIVACY.SECTION8.TEXT3":
      "Die Daten werden zur Verbesserung der Website und zur Analyse des Nutzerverhaltens verwendet. Sie werden nicht an Dritte weitergegeben, außer zur Speicherung bei unserem Hosting-Provider (Firebase/Google).",
    "PRIVACY.SECTION9.TITLE": "Rechtsgrundlage",
    "PRIVACY.SECTION9.TEXT1":
      "Soweit innerhalb dieser Datenschutzerklärung keine speziellere Rechtsgrundlage genannt wurde, gilt Folgendes:",
    "PRIVACY.SECTION9.TEXT2":
      "Die Rechtsgrundlage für die Einholung von Einwilligungen ist Art. 6 Abs. 1 lit. a und Art. 7 DSGVO, die Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer Leistungen und Durchführung vertraglicher Maßnahmen sowie Beantwortung von Anfragen ist Art. 6 Abs. 1 lit. b DSGVO, die Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer rechtlichen Verpflichtungen ist Art. 6 Abs. 1 lit. c DSGVO, und die Rechtsgrundlage für die Verarbeitung zur Wahrung unserer berechtigten Interessen ist Art. 6 Abs. 1 lit. f DSGVO.",
    "PRIVACY.SECTION10.TITLE": "Speicherdauer",
    "PRIVACY.SECTION10.TEXT1":
      "Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben.",
    "PRIVACY.SECTION10.TEXT2":
      "Kontaktformular-Daten werden gelöscht, sobald sie zur Bearbeitung Ihrer Anfrage nicht mehr erforderlich sind, es sei denn, gesetzliche Aufbewahrungspflichten bestehen. Newsletter-Abonnements bleiben gespeichert, bis Sie sich abmelden. Besucher-Tracking-Daten werden nach maximal 24 Monaten gelöscht.",
    "PRIVACY.SECTION11.TITLE": "Datenübermittlung in Drittländer",
    "PRIVACY.SECTION11.TEXT1":
      "Wir nutzen Firebase (Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA) zur Speicherung von Besucherdaten und Newsletter-Abonnements. Firebase kann Daten auch auf Servern außerhalb der EU verarbeiten.",
    "PRIVACY.SECTION11.TEXT2":
      "Google LLC hat sich dem EU-US Data Privacy Framework unterworfen. Durch das EU-US Data Privacy Framework besteht ein angemessenes Datenschutzniveau gemäß Art. 45 DSGVO. Weitere Informationen finden Sie hier:",
    "PRIVACY.SECTION11.LINK":
      "https://www.dataprivacyframework.gov/s/participant-search",
    "PRIVACY.SECTION11.TEXT3":
      "Die Übermittlung erfolgt auf Grundlage von Art. 45 DSGVO (Angemessenheitsbeschluss).",
    "PRIVACY.SECTION12.TITLE":
      "Widerruf Ihrer Einwilligung zur Datenverarbeitung",
    "PRIVACY.SECTION12.TEXT":
      "Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.",
    "PRIVACY.SECTION13.TITLE":
      "Beschwerderecht bei der zuständigen Aufsichtsbehörde",
    "PRIVACY.SECTION13.TEXT":
      "Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.",
    "IMPRINT.TITLE": "Impressum",
    "IMPRINT.SECTION1.TITLE": "Angaben gemäß § 5 TMG",
    "IMPRINT.SECTION2.TITLE": "Kontakt",
    "IMPRINT.SECTION2.PHONE": "Telefon",
    "IMPRINT.SECTION2.EMAIL": "E-Mail",
    "IMPRINT.SECTION3.TITLE": "EU-Streitschlichtung",
    "IMPRINT.SECTION3.TEXT1":
      "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:",
    "IMPRINT.SECTION3.TEXT2":
      "Unsere E-Mail-Adresse finden Sie oben im Impressum.",
    "IMPRINT.SECTION4.TITLE":
      "Verbraucherstreitbeilegung/Universalschlichtungsstelle",
    "IMPRINT.SECTION4.TEXT":
      "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
    "IMPRINT.SECTION6.TITLE": "Haftungsausschluss",
    "IMPRINT.SECTION6.SUBTITLE1": "Haftung für Inhalte",
    "IMPRINT.SECTION6.TEXT1":
      "Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.",
    "IMPRINT.SECTION6.TEXT2":
      "Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.",
    "IMPRINT.SECTION6.SUBTITLE2": "Haftung für Links",
    "IMPRINT.SECTION6.TEXT3":
      "Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.",
    "IMPRINT.SECTION6.TEXT4":
      "Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.",
    "IMPRINT.SECTION6.SUBTITLE3": "Urheberrecht",
    "IMPRINT.SECTION6.TEXT5":
      "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.",
    "IMPRINT.SECTION6.TEXT6":
      "Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.",
    "FOOTER.TAGLINE": "Maßgeschneiderte Software-Entwicklung",
    "FOOTER.NAVIGATION": "Navigation",
    "FOOTER.SOCIAL": "Social",
    "BLOG.TITLE": "Blog",
    "BLOG.SUBTITLE":
      "Gedanken, Ideen und Erkenntnisse aus der Welt der Webentwicklung",
    "BLOG.LOADING": "Blog-Posts werden geladen...",
    "BLOG.NO_POSTS": "Noch keine Blog-Posts vorhanden.",
    "BLOG.READ_MORE": "Weiterlesen",
    "BLOG.BACK_TO_BLOG": "Zurück zum Blog",
    "BLOG.POST_LOADING": "Blog-Post wird geladen...",
    "BLOG.POST_NOT_FOUND": "Blog-Post nicht gefunden",
    "BLOG.POST_NOT_FOUND_TEXT":
      "Der gesuchte Blog-Post existiert nicht oder wurde entfernt.",
  },
  en: {
    "NAV.HOME": "Home",
    "NAV.ABOUT": "Services",
    "NAV.SKILLS": "Technologies",
    "NAV.PROJECTS": "References",
    "NAV.BLOG": "Blog",
    "NAV.CONTACT": "Contact",
    "HERO.GREETING": "Digital Solutions for Your Business",
    "HERO.TITLE": "Tailored Software Development",
    "HERO.DESCRIPTION":
      "I transform your visions into powerful, scalable digital products. From modern web apps to complex applications – I deliver results that drive your business forward.",
    "HERO.CTA.QUOTE": "Discuss Project",
    "HERO.CTA.WORK": "Request References",
    "TRUST.TITLE": "On the Right Track with Me",
    "TRUST.SUBTITLE": "Your IT Solution in Best Hands",
    "TRUST.BENEFITS.TITLE": "Your Benefits",
    "TRUST.BENEFITS.B1.TITLE": "Faster Time to Market",
    "TRUST.BENEFITS.B1.DESC":
      "Efficient development saves time and brings your product to market faster.",
    "TRUST.BENEFITS.B2.TITLE": "Cost Savings",
    "TRUST.BENEFITS.B2.DESC":
      "Optimized solutions reduce long-term operating costs and increase your profitability.",
    "TRUST.BENEFITS.B3.TITLE": "Scalable Solutions",
    "TRUST.BENEFITS.B3.DESC":
      "Your IT infrastructure grows with your business – today and in the future.",
    "TRUST.PROMISE.TITLE": "My Promise",
    "TRUST.PROMISE.P1.TITLE": "Quality Guaranteed",
    "TRUST.PROMISE.P1.DESC":
      "High-quality code and proven best practices for long-term stability.",
    "TRUST.PROMISE.P2.TITLE": "Transparent Communication",
    "TRUST.PROMISE.P2.DESC":
      "Regular updates and clear communication – you always know where your project stands.",
    "TRUST.PROMISE.P3.TITLE": "On-Time Delivery",
    "TRUST.PROMISE.P3.DESC":
      "Punctuality is a given. Your deadlines are my priority.",
    "TRUST.PROCESS.TITLE": "My Process",
    "TRUST.PROCESS.S1.TITLE": "Analysis",
    "TRUST.PROCESS.S1.DESC":
      "In-depth analysis of your requirements and goals.",
    "TRUST.PROCESS.S2.TITLE": "Planning",
    "TRUST.PROCESS.S2.DESC":
      "Strategic planning for the optimal solution path.",
    "TRUST.PROCESS.S3.TITLE": "Development",
    "TRUST.PROCESS.S3.DESC": "Agile development with regular feedback loops.",
    "TRUST.PROCESS.S4.TITLE": "Launch",
    "TRUST.PROCESS.S4.DESC":
      "Careful deployment and ongoing support after launch.",
    "ABOUT.TITLE":
      "I'm a Fullstack Developer and offer you the best IT solution",
    "ABOUT.BIO":
      "From idea to launch – I accompany your project from start to finish. Frontend, Backend, Mobile Apps, and Cloud Infrastructure all in one.",
    "ABOUT.H1": "Customer Focus",
    "ABOUT.H2": "Scalable",
    "ABOUT.H3": "Support",
    "ABOUT.S1.TITLE": "Web & Apps",
    "ABOUT.S1.DESC":
      "Modern web applications and mobile apps for all platforms",
    "ABOUT.S2.TITLE": "Cloud & DevOps",
    "ABOUT.S2.DESC":
      "Scalable infrastructure and automated deployment processes",
    "ABOUT.S3.TITLE": "Mobile Development",
    "ABOUT.S3.DESC": "Native iOS apps and cross-platform solutions",
    "EXPERIENCE.TITLE": "Concrete Business Benefits",
    "EXPERIENCE.JOB1.TITLE": "Web & App Development",
    "EXPERIENCE.JOB1.COMPANY": "Frontend, Backend & Mobile",
    "EXPERIENCE.JOB1.DATE": "Fullstack",
    "EXPERIENCE.JOB1.DESC":
      "I develop everything from basic websites to complex web applications (Frontend, Backend & Database), backend systems, and native mobile apps. Tailored solutions for your needs.",
    "EXPERIENCE.JOB2.TITLE": "Cloud & Programmatic SEO",
    "EXPERIENCE.JOB2.COMPANY": "Scalable & Visible",
    "EXPERIENCE.JOB2.DATE": "Cloud Native",
    "EXPERIENCE.JOB2.DESC":
      "Whether Supabase, Firebase, AWS, or GCP – using modern cloud technologies is no problem. Additionally, I offer Programmatic SEO optimization for maximum visibility.",
    "SKILLS.TITLE": "Technologies That Secure Your Success",
    "SKILLS.SUBTITLE":
      "From Frontend to Mobile – the right tools for your project",
    "SKILLS.FRONTEND.TITLE": "Modern Web Applications",
    "SKILLS.BACKEND.TITLE": "Robust Business Logic",
    "SKILLS.MOBILE.TITLE": "Native & Cross-Platform Apps",
    "SKILLS.CLOUD.TITLE": "Scalable Cloud Infrastructure",
    "PROJECTS.TITLE": "Success Stories",
    "PROJECTS.SUBTITLE": "Solutions That Deliver Results",
    "PROJECTS.P1.TITLE": "E-Commerce Platform",
    "PROJECTS.P1.DESC":
      "40% increase in online sales through modern e-commerce solution with real-time inventory management and optimized user experience.",
    "PROJECTS.P2.TITLE": "Task Management App",
    "PROJECTS.P2.DESC":
      "60% efficiency increase through collaborative task management tool. Teams work more productively thanks to real-time updates and seamless synchronization.",
    "PROJECTS.P3.TITLE": "Online presence for a vehicle inspection center",
    "PROJECTS.P3.DESC":
      "Professional online presence with improved visibility: 3x more leads through optimized performance and modern design language.",
    "PROJECTS.VIEW_CODE": "View Code",
    "PROJECTS.LIVE_DEMO": "Live Demo",
    "CONTACT.TITLE": "Let's Start Your Project",
    "CONTACT.SUBTITLE": "Ready to take your business to the next level?",
    "CONTACT.TEXT":
      "Let's turn your vision into a profitable reality together. I develop tailored IT solutions that drive your business forward and deliver measurable results.",
    "CONTACT.FORM.NAME": "Your Name",
    "CONTACT.FORM.EMAIL": "Your Email",
    "CONTACT.FORM.PHONE": "Phone Number (Optional)",
    "CONTACT.FORM.PROJECT_TYPE": "Project Type",
    "CONTACT.FORM.PROJECT_TYPE.WEBSITE": "Website",
    "CONTACT.FORM.PROJECT_TYPE.WEBAPP": "Web Application",
    "CONTACT.FORM.PROJECT_TYPE.MOBILE": "Mobile App",
    "CONTACT.FORM.PROJECT_TYPE.CLOUD": "Cloud & DevOps",
    "CONTACT.FORM.PROJECT_TYPE.SEO": "SEO Optimization",
    "CONTACT.FORM.PROJECT_TYPE.BACKENDPROCESS": "Server-side Application",
    "CONTACT.FORM.PROJECT_TYPE.OTHER": "Other",
    "CONTACT.FORM.BUDGET": "Budget Range",
    "CONTACT.FORM.BUDGET.LOW": "Under 2.000€",
    "CONTACT.FORM.BUDGET.MEDIUM": "2.000€ - 5.000€",
    "CONTACT.FORM.BUDGET.HIGH": "5.000€ - 10.000€",
    "CONTACT.FORM.BUDGET.PREMIUM": "Above 10.000€",
    "CONTACT.FORM.SUBJECT": "Subject",
    "CONTACT.FORM.MESSAGE": "Your Message",
    "CONTACT.FORM.SUBMIT": "Send Inquiry",
    "CONTACT.ADDRESS": "Munich, Germany",
    "CONTACT.SUCCESS":
      "Thank you for your message! I will get back to you soon.",
    "CONTACT.ERROR":
      "Sorry, there was an error sending your message. Please try again later or email me directly at kontakt@koricode.de.",
    "CONTACT.TIMEOUT":
      "The request is taking longer than expected. Your email program will be opened.",
    "CONTACT.FALLBACK":
      "Your email program has been opened. Please send the message from there.",
    "NEWSLETTER.SUCCESS":
      "Thank you for subscribing! You have successfully registered for the newsletter.",
    "NEWSLETTER.ERROR": "An error occurred. Please try again later.",
    "NEWSLETTER.TITLE": "Stay Updated",
    "NEWSLETTER.DESCRIPTION":
      "Subscribe to my newsletter and get the latest updates on projects, blog posts, and technology trends directly in your inbox.",
    "NEWSLETTER.FORM.EMAIL_PLACEHOLDER": "Your Email Address",
    "NEWSLETTER.FORM.REQUIRED": "Email address is required",
    "NEWSLETTER.FORM.INVALID": "Please enter a valid email address",
    "NEWSLETTER.FORM.SUBMIT": "Subscribe",
    "NEWSLETTER.FORM.SUBMITTING": "Sending...",
    "COOKIE.TITLE": "Cookie Settings",
    "COOKIE.TEXT":
      "We use cookies to improve your experience and collect anonymous usage data. You can decide which cookies you want to allow.",
    "COOKIE.ACCEPT_ALL": "Accept All",
    "COOKIE.NECESSARY": "Necessary Only",
    "FOOTER.RIGHTS": "All rights reserved.",
    "FOOTER.LEGAL.IMPRESSUM": "Imprint",
    "FOOTER.LEGAL.PRIVACY": "Privacy Policy",
    "PRIVACY.TITLE": "Privacy Policy",
    "PRIVACY.STATUS": "Last Updated",
    "PRIVACY.MONTH.1": "January",
    "PRIVACY.MONTH.2": "February",
    "PRIVACY.MONTH.3": "March",
    "PRIVACY.MONTH.4": "April",
    "PRIVACY.MONTH.5": "May",
    "PRIVACY.MONTH.6": "June",
    "PRIVACY.MONTH.7": "July",
    "PRIVACY.MONTH.8": "August",
    "PRIVACY.MONTH.9": "September",
    "PRIVACY.MONTH.10": "October",
    "PRIVACY.MONTH.11": "November",
    "PRIVACY.MONTH.12": "December",
    "PRIVACY.SECTION1.TITLE": "Privacy at a Glance",
    "PRIVACY.SECTION1.SUBTITLE": "General Information",
    "PRIVACY.SECTION1.TEXT":
      "The following information provides an easy-to-understand overview of what happens to your personal data when you visit this website. Personal data is any data that can personally identify you.",
    "PRIVACY.SECTION2.TITLE": "Data Collection on This Website",
    "PRIVACY.SECTION2.Q1":
      "Who is responsible for data collection on this website?",
    "PRIVACY.SECTION2.A1":
      "Data processing on this website is carried out by the website operator. You can find their contact details in the imprint of this website.",
    "PRIVACY.SECTION2.Q2": "How do we collect your data?",
    "PRIVACY.SECTION2.A2.P1":
      "Your data is collected in part by you providing it to us. This may, for example, be data that you enter in a contact form.",
    "PRIVACY.SECTION2.A2.P2":
      "Other data is collected automatically or with your consent when you visit the website through our IT systems and is used exclusively for statistical purposes to improve our services.",
    "PRIVACY.SECTION3.TITLE": "Cookies",
    "PRIVACY.SECTION3.P1":
      "Our website uses cookies. These are small text files that your web browser stores on your device. Cookies help make the website more user-friendly.",
    "PRIVACY.SECTION3.P2": "We use the following cookie categories:",
    "PRIVACY.SECTION3.NECESSARY": "Necessary Cookies:",
    "PRIVACY.SECTION3.NECESSARY.DESC": "Enable basic website functions",
    "PRIVACY.SECTION3.ANALYTICAL": "Analytical Cookies:",
    "PRIVACY.SECTION3.ANALYTICAL.DESC":
      "Help us understand website usage (only with your consent)",
    "PRIVACY.SECTION3.P3":
      "You can change your cookie settings at any time via the cookie banner at the bottom of the screen.",
    "PRIVACY.SECTION4.TITLE": "Contact Form",
    "PRIVACY.SECTION4.TEXT":
      "If you send us inquiries via the contact form, your information from the inquiry form, including the contact details you provide, will be stored by us for the purpose of processing the inquiry and in case of follow-up questions.",
    "PRIVACY.SECTION5.TITLE": "Your Rights",
    "PRIVACY.SECTION5.INTRO": "You have the right at any time to:",
    "PRIVACY.SECTION5.RIGHT1":
      "Obtain information about your personal data stored by us",
    "PRIVACY.SECTION5.RIGHT2": "Request correction of incorrect data",
    "PRIVACY.SECTION5.RIGHT3": "Request deletion of your data",
    "PRIVACY.SECTION5.RIGHT4": "Request restriction of data processing",
    "PRIVACY.SECTION5.RIGHT5": "Object to data processing",
    "PRIVACY.SECTION5.RIGHT6": "Request data portability",
    "PRIVACY.SECTION5.CONTACT": "For this, please contact: kontakt@koricode.de",
    "PRIVACY.SECTION6.TITLE": "Newsletter",
    "PRIVACY.SECTION6.TEXT1":
      "If you wish to subscribe to the newsletter offered on this website, we require an email address from you as well as information that allows us to verify that you are the owner of the specified email address and agree to receive the newsletter.",
    "PRIVACY.SECTION6.TEXT2":
      "The legal basis for the processing of data after registration for the newsletter is, if consent is given, Art. 6 Para. 1 lit. a GDPR. You can revoke your consent to receive the newsletter at any time, for example via the unsubscribe link in the newsletter. The legality of the data processing operations already carried out remains unaffected by the revocation.",
    "PRIVACY.SECTION7.TITLE": "Server Log Files",
    "PRIVACY.SECTION7.TEXT":
      "The provider of the pages automatically collects and stores information in so-called server log files, which your browser automatically transmits to us. A combination of this data with other data sources is not carried out. The collection of this data is based on Art. 6 Para. 1 lit. f GDPR. The website operator has a legitimate interest in the technically error-free presentation and optimization of his website - for this purpose the server log files must be recorded.",
    "PRIVACY.SECTION8.TITLE": "Visitor Tracking",
    "PRIVACY.SECTION8.TEXT1":
      "This website uses a visitor tracking system to collect statistical information about website usage. The following data is collected and stored:",
    "PRIVACY.SECTION8.LIST1": "IP address",
    "PRIVACY.SECTION8.LIST2": "User-Agent (browser type and version)",
    "PRIVACY.SECTION8.LIST3": "Language settings",
    "PRIVACY.SECTION8.LIST4": "Referrer URL (which page you came from)",
    "PRIVACY.SECTION8.LIST5": "Screen resolution and color depth",
    "PRIVACY.SECTION8.LIST6": "Time zone",
    "PRIVACY.SECTION8.LIST7": "Hardware information (if available)",
    "PRIVACY.SECTION8.LIST8": "Pages visited",
    "PRIVACY.SECTION8.TEXT2":
      "The collection of this data only takes place with your explicit consent (Art. 6 Para. 1 lit. a GDPR) via our cookie banner. You can revoke your consent at any time by adjusting your cookie settings.",
    "PRIVACY.SECTION8.TEXT3":
      "The data is used to improve the website and analyze user behavior. It is not passed on to third parties, except for storage with our hosting provider (Firebase/Google).",
    "PRIVACY.SECTION9.TITLE": "Legal Basis",
    "PRIVACY.SECTION9.TEXT1":
      "Insofar as no more specific legal basis is mentioned in this data protection declaration, the following applies:",
    "PRIVACY.SECTION9.TEXT2":
      "The legal basis for obtaining consent is Art. 6 Para. 1 lit. a and Art. 7 GDPR, the legal basis for processing to fulfill our services and carry out contractual measures and answer inquiries is Art. 6 Para. 1 lit. b GDPR, the legal basis for processing to fulfill our legal obligations is Art. 6 Para. 1 lit. c GDPR, and the legal basis for processing to safeguard our legitimate interests is Art. 6 Para. 1 lit. f GDPR.",
    "PRIVACY.SECTION10.TITLE": "Storage Duration",
    "PRIVACY.SECTION10.TEXT1":
      "Insofar as no more specific storage period is mentioned within this data protection declaration, your personal data will remain with us until the purpose for data processing no longer applies. If you assert a legitimate request for deletion or revoke your consent to data processing, your data will be deleted unless we have other legally permissible reasons for storing your personal data.",
    "PRIVACY.SECTION10.TEXT2":
      "Contact form data will be deleted as soon as it is no longer required to process your request, unless there are legal retention requirements. Newsletter subscriptions remain stored until you unsubscribe. Visitor tracking data will be deleted after a maximum of 24 months.",
    "PRIVACY.SECTION11.TITLE": "Data Transfer to Third Countries",
    "PRIVACY.SECTION11.TEXT1":
      "We use Firebase (Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA) to store visitor data and newsletter subscriptions. Firebase may also process data on servers outside the EU.",
    "PRIVACY.SECTION11.TEXT2":
      "Google LLC has submitted to the EU-US Data Privacy Framework. Through the EU-US Data Privacy Framework, there is an adequate level of data protection in accordance with Art. 45 GDPR. Further information can be found here:",
    "PRIVACY.SECTION11.LINK":
      "https://www.dataprivacyframework.gov/s/participant-search",
    "PRIVACY.SECTION11.TEXT3":
      "The transfer is based on Art. 45 GDPR (adequacy decision).",
    "PRIVACY.SECTION12.TITLE": "Revocation of Your Consent to Data Processing",
    "PRIVACY.SECTION12.TEXT":
      "Many data processing operations are only possible with your express consent. You can revoke consent you have already given at any time. The legality of the data processing carried out until the revocation remains unaffected by the revocation.",
    "PRIVACY.SECTION13.TITLE":
      "Right to Complain to the Competent Supervisory Authority",
    "PRIVACY.SECTION13.TEXT":
      "In the event of violations of the GDPR, data subjects have the right to lodge a complaint with a supervisory authority, in particular in the member state of their habitual residence, their place of work or the place of the alleged violation. The right to lodge a complaint exists without prejudice to other administrative or judicial remedies.",
    "IMPRINT.TITLE": "Imprint",
    "IMPRINT.SECTION1.TITLE": "Information according to § 5 TMG",
    "IMPRINT.SECTION2.TITLE": "Contact",
    "IMPRINT.SECTION2.PHONE": "Phone",
    "IMPRINT.SECTION2.EMAIL": "Email",
    "IMPRINT.SECTION3.TITLE": "EU Dispute Resolution",
    "IMPRINT.SECTION3.TEXT1":
      "The European Commission provides a platform for online dispute resolution (ODR):",
    "IMPRINT.SECTION3.TEXT2":
      "You can find our email address in the imprint above.",
    "IMPRINT.SECTION4.TITLE":
      "Consumer Dispute Resolution/Universal Arbitration Board",
    "IMPRINT.SECTION4.TEXT":
      "We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.",
    "IMPRINT.SECTION6.TITLE": "Disclaimer",
    "IMPRINT.SECTION6.SUBTITLE1": "Liability for Contents",
    "IMPRINT.SECTION6.TEXT1":
      "As a service provider, we are responsible for our own content on these pages in accordance with § 7 Para. 1 TMG (German Telemedia Act). However, according to §§ 8 to 10 TMG, we as a service provider are not under obligation to permanently monitor submitted or stored information or to search for evidences that indicate illegal activities.",
    "IMPRINT.SECTION6.TEXT2":
      "Legal obligations to removing information or to blocking the use of information remain unchallenged. In this case, liability is only possible at the time of knowledge of a specific violation of law. Illegal contents will be removed immediately at the time we get knowledge of them.",
    "IMPRINT.SECTION6.SUBTITLE2": "Liability for Links",
    "IMPRINT.SECTION6.TEXT3":
      "Our offer includes links to external websites of third parties on whose contents we have no influence. Therefore, we cannot assume any liability for these external contents. The respective provider or operator of the websites is always responsible for the contents of the linked websites. The linked websites had been checked for possible violations of law at the time of the establishment of the link. Illegal contents were not detected at the time of the linking.",
    "IMPRINT.SECTION6.TEXT4":
      "However, a permanent monitoring of the contents of the linked websites cannot be imposed without reasonable indications that there has been a violation of law. Illegal links will be removed immediately at the time we get knowledge of them.",
    "IMPRINT.SECTION6.SUBTITLE3": "Copyright",
    "IMPRINT.SECTION6.TEXT5":
      "Contents and compilations published on these websites by the providers are subject to German copyright laws. Reproduction, editing, distribution as well as the use of any kind outside the scope of the copyright law require a written permission of the author or originator. Downloads and copies of these websites are permitted for private use only. The commercial use of our contents without permission of the original author is prohibited.",
    "IMPRINT.SECTION6.TEXT6":
      "Copyright laws of third parties are respected as long as the contents on these websites do not originate from the provider. Contributions of third parties on this site are indicated as such. However, if you notice any violations of copyright law, please inform us. Such contents will be removed immediately.",
    "FOOTER.TAGLINE": "Tailored Software Development",
    "FOOTER.NAVIGATION": "Navigation",
    "FOOTER.SOCIAL": "Social",
    "BLOG.TITLE": "Blog",
    "BLOG.SUBTITLE":
      "Thoughts, ideas and insights from the world of web development",
    "BLOG.LOADING": "Loading blog posts...",
    "BLOG.NO_POSTS": "No blog posts available yet.",
    "BLOG.READ_MORE": "Read more",
    "BLOG.BACK_TO_BLOG": "Back to Blog",
    "BLOG.POST_LOADING": "Loading blog post...",
    "BLOG.POST_NOT_FOUND": "Blog Post Not Found",
    "BLOG.POST_NOT_FOUND_TEXT":
      "The blog post you are looking for does not exist or has been removed.",
  },
};

export { translations };
